<template>
  <div class="mobileProduct">
    <div class="header">
      <a href="javascript:;"
         @click="$router.back(-1)">
        <van-icon name="arrow-left"
                  class="header-left" />
      </a>
      <a href="javascript:;"
         class="gohome"
         @click="goHome">
        <van-icon name="wap-home"
                  class="header-home" />
      </a>
      <span>{{title}}</span>
    </div>
    <div class="productOne"
         ref="productOne">
      <Header :product="product"
              :specs="specs" />
      <Specs :product="product"
             :specs="specs"
             @changeSpecs="changeSpecs"
             @changeNumber="changeNumber"
             @changeShow="changeShow"
             v-if="specs[0]" />
      <oldProduct :assess="assess" />
      <Bonus :product="product" />
    </div>
    <!-- {{account}} -->
    <Content :account="account"
             @changeContent="changeContent" />
    <Tabs :product="product" />
    <div class="productFooter clearfix"
         v-if="assess.assessAmount">
      <div class="left">
        <p>
          环保补助金
          <span>-¥{{product.bonus_price}}</span>
        </p>
        <p>
          环保优惠券
          <span v-if="user.bonus.value">-¥{{user.bonus.value}}</span><span v-else>¥0</span>
        </p>
        <p>
          旧机评估价
          <span>-¥{{assess.assessAmount}}</span>
        </p>
      </div>
      <div class="right">
        <div v-if="specs[0]"
             class="right-text">
          <span>
            <em>¥</em>
            {{Math.abs((parseInt(product.price)+parseInt(specs[0].price)+parseInt(specs[1].price)-product.bonus_price)*number-user.bonus.value-assess.assessAmount)}}
          </span>
          <span v-if="((parseInt(product.price)+parseInt(specs[0].price)+parseInt(specs[1].price)-product.bonus_price)*number-user.bonus.value-assess.assessAmount)>0">预计到手价</span>
          <span v-else>「0元换」额外赚</span>
        </div>
        <van-button type="danger"
                    v-if="!loadding"
                    @click="Next()">立即换新</van-button>
        <van-button loading
                    type="danger"
                    v-else
                    loading-type="spinner"
                    loading-text="提交中..." />
      </div>
    </div>
    <div class="productFooter clearfix"
         v-else>
      <div class="left">
        <p style="margin:0.24rem 0 0 0.2rem;font-size:0.18rem">添加旧机 享受超额优惠</p>
      </div>
      <div class="right">
        <van-button type="danger"
                    @click="goOld">立即添加</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { encrypt, setCookie, getCookie } from "@/utils";

import Header from "@/components/Mobile/Product/Header.vue";
import Specs from "@/components/Mobile/Product/Specs.vue";
import oldProduct from "@/components/Mobile/Product/oldProduct.vue";
import Bonus from "@/components/Mobile/Product/Bonus.vue";
import Tabs from "@/components/Mobile/Product/Tabs.vue";
import Content from "@/components/Mobile/Product/Content.vue";

export default {
  name: "Order",
  data () {
    return {
      active: 2,
      ordersn: {},
      checked: true,
      specs: [
        // {value:1,price:0},
        // {value:2,price:0},
      ],
      amount: 0,
      form: {
        name: "",
        phone: "",
        city: [],
        address: ""
      },
      number: 1,
      loadding: false,
      title: "换新详情"
    };
  },
  components: {
    Header,
    Specs,
    oldProduct,
    Content,
    Bonus,
    Tabs
  },
  mounted: function () {
    window.scroll(0, 0);
    window.addEventListener("scroll", () => {
      // console.log(this.$refs.product.scrollTop);
    });
    this.form = this.info;
  },
  computed: {
    product () {
      return this.$store.state.product.product;
    },
    assess () {
      return this.$store.state.assess.assess;
    },
    account () {
      return this.$store.state.account.user;
    },
    user () {
      return this.$store.state.user;
    },
    info () {
      return this.$store.state.user.info;
    }
  },
  methods: {
    goHome () {
      this.$router.push({ path: "/mobile" });

    },
    fetchProductData (params) {
      this.$store.dispatch("product/fetchProductData", { params }).then(() => {
        for (let i = 0; i < this.product.attr.length; i++) {
          for (let j = 0; j < this.product.attr[i]["attr_value"].length; j++) {
            if (j == 0) {
              let data = {
                value: this.product.attr[i]["attr_value"][0]["attr_value_id"],
                price: this.product.attr[i]["attr_value"][0]["attr_price"],
                name: this.product.attr[i]["attr_value"][0]["attr_value_name"]
              };
              this.specs.push(data);
            }
          }
        }
        this.amount = this.product.price;
        this.title = this.product.title.substring(0, 20);
        if (this.account.userid) {
          this.BonusList(this.account.userid, this.product.price);
        }
      });
    },
    BonusList (userid, amount) {
      let params = {
        id: userid,
        type: 1,
        amount: amount,
        shoptype: 1
      };
      this.$store.dispatch("user/fetchBonusList", { params }).then(() => {
        if (this.user.bonuslist.length) {
          this.$store.commit("user/setBonus", this.user.bonuslist[0]);
        }
      });
    },
    changeSpecs (data) {
      console.log(data);
      this.specs = data;
    },
    changeNumber (data) {
      this.number = data;
    },
    changeShow (data) {
      this.show = !this.show;
    },
    changeContent (value) {
      this.form = value;
    },
    handleScroll () {
      var sortMenu = this.$refs.product.scrollTop;
    },
    goOld () {
      this.$router.push({ path: "/mobile/category" });

    },
    Next () {
      if (!this.assess.goodsId) {
        this.$toast("必须添加旧机才能换新.");
        return false;
      }
      let attrids = "";
      let attrs = "";
      let amount =
        parseInt(this.product.price) - parseInt(this.product.bonus_price) - parseInt(this.user.bonus.value);
      for (let i = 0; i < this.specs.length; i++) {
        attrids += this.specs[i].value + ",";
        attrs += this.specs[i].name + ",";
        amount += parseInt(this.specs[i].price);
      }
      if (!this.info.name) {
        window.scrollTo(0, this.$refs.productOne.offsetHeight)
        this.$toast("请输入您的收货信息.");
        return false;
      }
      if (!this.account.userid) {
        this.$toast("请先获取验证码登录.");
        return false;
      }
      if (this.account.mobile.length>11||this.account.mobile.length===0) {
        this.$store.commit('account/setUserMobile', '')
        this.$toast("请输入您的手机号及验证码.");
        return false;
      }
      let referer = getCookie("referer");
      this.loadding = !this.loadding;
      let params = {
        goodsid: this.product.id,
        number: this.number,
        name: this.info.name,
        mobile: this.account.mobile,
        userid: this.account.userid,
        address: this.info.city + this.info.address,
        referer: "Mobile" + referer,
        source: 1,
        bonus: this.user.bonus.value,
        bonusid: this.user.bonus.id,
        amount: amount * this.number,
        attrids: attrids,
        attrs: attrs,
        oldattrids: this.assess.assessAttrId,
        oldattrs: this.assess.assessAttr,
        oldgoodsid: this.assess.goodsId,
        oldamount: this.assess.assessAmount
      };
      // console.log(params);
      // return false;
      this.$store.dispatch("order/fetchCreateOrder", { params }).then(() => {
        let neworder = JSON.stringify(this.$store.state.order.neworder);
        setCookie("neworder", encrypt(neworder), true);
        this.$router.push({ path: "/mobile/checkout" });
      });
    }
  },
  created () {
    let id = this.$route.params.id;
    let params = {
      id: id
    };
    this.fetchProductData(params);
  },
  watch: {}
};
</script>
<style>
.mobileProduct {
  background: #f5f5f5;
  padding: 0rem 0 1rem;
}
.mobileProduct .header {
  height: 0.44rem;
  line-height: 0.44rem;
  text-align: center;
  position: relative;
  background: #fff;
  font-size: 0.17rem;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}
.mobiletProduct .header span {
  display: inline-block;
  width: 2rem;
  overflow: hidden;
  height: 0.44rem;
}

.mobileProduct .header .header-left {
  position: absolute;
  left: 0.1rem;
  top: 0.13rem;
}
.mobileProduct .header .header-home {
  position: absolute;
  left: 0.35rem;
  top: 0.13rem;
}
.mobileProduct .productFooter {
  box-shadow: #efefef 0 0 0.1rem;
  height: 0.63rem;
  position: fixed;
  width: 100%;
  background: #fff;
  bottom: 0;
  left: 0;
  z-index: 99;
}
.mobileProduct .productFooter .left {
  float: left;
  font-size: 0.12rem;
  padding: 0rem 0 0 0.14rem;
}
.mobileProduct .productFooter .left p {
  margin: 0.06rem 0 0 0.1em;
  color: #999;
}
.mobileProduct .productFooter .left p span {
  color: #666;
}
.mobileProduct .productFooter .right {
  float: right;
  display: flex;
  font-size: 0.14rem;
}
.mobileProduct .productFooter .right .right-text {
  text-align: center;
  margin-right: 0.12rem;
  color: #333;
  padding: 0.13rem 0;
}
.mobileProduct .productFooter .right .right-text span:nth-child(1) {
  display: block;
  font-size: 0.2rem;
  color: #f9415d;
}
.mobileProduct .productFooter .right .right-text span em {
  font-style: normal;
  font-size: 0.12rem;
}
.mobileProduct .productFooter .right button {
  display: inline-block;
  width: 1.14rem;
  height: 0.63rem;
  background: rgba(249, 65, 93, 1);
  font-size: 0.15rem;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
}
.item-content-img {
  width: 3.48rem;
  height: 1.6rem;
  background: url(../../../assets/image/mobileStepBg.png) no-repeat;
  background-size: 100%;
  margin-top: 0.1rem;
}
</style>
